import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ru from "./ru.json";
import oz from "./oz.json";
import uz from "./uz.json";

const resources = {
  ru: { translation: ru },
  oz: { translation: oz },
  uz: { translation: uz },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: localStorage.getItem("i18nextLng") ?? "ru",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
